import { toCitySlug } from '@/utils/formatters/city/to-city-slug.util';

export interface CityLocation {
  city?: string;
  state?: string;
}

export function isDifferentCity(one?: CityLocation, other?: CityLocation): boolean {
  const oneSlug = toCitySlug(one?.city, one?.state);
  const otherSlug = toCitySlug(other?.city, other?.state);

  if (!oneSlug || !otherSlug) {
    return false;
  }

  return oneSlug !== otherSlug;
}
